module.exports = __webpack_public_path__ + "img/nt52-01a-80-1.prt.c7da4d3e.jpg";